export const MENUITEMS = [
  {
    menuuser: "ADMIN",
    menutitle: "General",
    menucontent: "Ready to use Apps",
    Items: [
      {
        title: "REPORT",
        icon: "task",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/dashboard/report/summarize-report`,
            type: "link",
            title: "SUMMARIZE-REPORT",
          },
          {
            path: `${process.env.PUBLIC_URL}/dashboard/report/report-by-product`,
            type: "link",
            title: "REPORT-BY-PRODUCT",
          },
          {
            path: `${process.env.PUBLIC_URL}/dashboard/report/subscribers-list`,
            type: "link",
            title: "SUBSCRIBERS-LIST",
          },
          {
            path: `${process.env.PUBLIC_URL}/dashboard/report/active-count`,
            type: "link",
            title: "ACTIVE-COUNT",
          },
          {
            path: `${process.env.PUBLIC_URL}/dashboard/report/active-list`,
            type: "link",
            title: "ACTIVE-LIST",
          },
        ],
      },
      {
        title: "PARTNER MANAGER",
        icon: "user",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/dashboard/usermanager/user-list`,
            title: "USER-LIST",
            type: "link",
          },
        ],
      },
      {
        title: "PRODUCT MANAGER",
        icon: "ecommerce",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/dashboard/product/create-product`,
            title: "CREATE-PRODUCT",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/dashboard/product/product-list`,
            title: "PRODUCT-LIST",
            type: "link",
          },
        ],
      },
      {
        title: "SHORTCODE MANAGER",
        icon: "bookmark",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/dashboard/shortcode/shortcode-list`,
            type: "link",
            title: "SHORTCODE-LIST",
          },
          {
            path: `${process.env.PUBLIC_URL}/dashboard/shortcode/subscribe`,
            type: "link",
            title: "SUBSCRIBE",
          },
          {
            path: `${process.env.PUBLIC_URL}/dashboard/shortcode/subscription-status`,
            type: "link",
            title: "SUBSCRIPTION-STATUS",
          },
        ],
      },
      {
        title: "CONFIGURATION",
        icon: "social",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/dashboard/configuration/help-message`,
            type: "link",
            title: "HELP-MESSAGE",
          },
          {
            path: `${process.env.PUBLIC_URL}/dashboard/configuration/invalid-keyword`,
            type: "link",
            title: "INVALID-KEYWORD",
          },
        ],
      },
      {
        title: "PARTNER",
        icon: "knowledgebase",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/dashboard/partner-shortcode`,
            title: "PARTNER-SHORTCODE",
            type: "link",
          },
        ],
      },
      {
        title: "Log tracer",
        icon: "task",
        type: "sub",
        active: false,
        children: [
          {
            path: `http://api.msrvas.com/admin/log`,
            title: "Server 1",
            type: "link",
            target: "_blank",
          },
          {
            path: `http://78.110.173.195:8000/admin/log`,
            title: "Server 2",
            type: "link",
            target: "_blank",
          },
        ],
      },
      {
        title: "API CHECKER",
        icon: "support-tickets",
        path: `${process.env.PUBLIC_URL}/dashboard/api-checker`,
        type: "link",
        active: false,
      },
    ],
  },

  {
    menuuser: "USER",
    menutitle: "General",
    menucontent: "Ready to use Apps",
    Items: [
      {
        title: "REPORT",
        icon: "task",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/partner/report/summarize-report`,
            type: "link",
            title: "SUMMARIZE-REPORT",
          },
          {
            path: `${process.env.PUBLIC_URL}/partner/report/report-by-product`,
            type: "link",
            title: "REPORT-BY-PRODUCT",
          },
          {
            path: `${process.env.PUBLIC_URL}/partner/report/subscribers-list`,
            type: "link",
            title: "SUBSCRIBERS-LIST",
          },
        ],
      },
      {
        title: "PRODUCTS",
        icon: "ecommerce",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/partner/product/create-product`,
            title: "CREATE-PRODUCT",
            type: "link",
          },
          {
            path: `${process.env.PUBLIC_URL}/partner/product/product-list`,
            title: "PRODUCT-LIST",
            type: "link",
          },
        ],
      },
      {
        title: "MESSAGES",
        icon: "chat",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/partner/messages/send-message`,
            type: "link",
            title: "SEND-MESSAGE",
          },
        ],
      },
      {
        title: "NOTIFICATION",
        icon: "support-tickets",
        type: "sub",
        active: false,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/partner/notification/ussd-menu-request`,
            type: "link",
            title: "USSD-MENU-REQUEST",
          },
          {
            path: `${process.env.PUBLIC_URL}/partner/notification/sms`,
            type: "link",
            title: "SMS",
          },
          {
            path: `${process.env.PUBLIC_URL}/partner/notification/sync-subscription`,
            type: "link",
            title: "SYNC-SUBSCRIPTION",
          },
          {
            path: `${process.env.PUBLIC_URL}/partner/notification/sync-renewal`,
            type: "link",
            title: "SYNC-RENEWAL",
          },
          {
            path: `${process.env.PUBLIC_URL}/partner/notification/sync-unsubscription`,
            type: "link",
            title: "SYNC-UNSUBSCRIPTION",
          },
        ],
      },
    ],
  },
];
